import React from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  getMyUploads,
  getImageMetaData,
  displayMore,
  getSignedS3ImageURL
} from '../../utils/apputils';
import { chunk } from '../../utils/utilities';
import { Well } from 'react-bootstrap';
import { users } from '../../store/actions';
import { getResizedLibraryImage } from '../../utils/upload';
import { async_getSignedURL } from '../../utils/files';
import config from '../../utils/config.js';
import { s3UserImages } from '../../store/actions';
import Spinner from '../Spinner/Spinner.js';

const Library = connect(state => ({ user: state.users.user }))(({ user }) => {
  if (user !== null) {
    return (
      <div className="container-fluid columns account account-content">
        <div className="col col-side">
          <nav className="side-nav">
            <ul>
              <li className="side-nav-item js-orders">
                <Link to="/orders">Your orders</Link>
              </li>
              <li className="side-nav-item js-account">
                <Link to="/profile">Your account</Link>
              </li>
              <li className="side-nav-item active js-pics">
                <Link to="/library">Your pics</Link>
              </li>
            </ul>
          </nav>
        </div>
        <LibraryBody />
      </div>
    );
  } else {
    return (
      <div className="container">
        <h1>You need to login</h1>
        <Well className="account-well" bsSize="large">
          <p>Hit the 'Log in' button in the bar up there</p>
        </Well>
      </div>
    );
  }
});

class PreviewCard_Class extends React.Component {
  componentDidMount() {
    const { dispatch, imageKey, thumbKey } = this.props;
    getSignedS3ImageURL(imageKey, thumbKey, dispatch);
  }

  render() {
    const { signedThumbnailURLs, thumbKey, angle, name } = this.props;
    const imageURL = signedThumbnailURLs[thumbKey];
    return (
      <Col xs={8}>
        <div
          className="card library-card"
          style={{ transform: `rotate(${angle}deg)` }}
        >
          <h3 className="card-title">{name}</h3>
          <div className="card-img library-card-img">
            {imageURL && (
              <img
                src={imageURL}
                className="home-thumbnail"
                width="310"
                alt=""
              />
            )}
          </div>
        </div>
      </Col>
    );
  }
}

class ImageButton_Class extends React.Component {
  requestImageAtSize = (width, height, sizeDescription, key) => {
    const { dispatch } = this.props;
    if (sizeDescription === 'fullsize') {
      dispatch(s3UserImages.downloadingAlternateSize(key, sizeDescription));
      // We just want the uuid of the user image from the full s3 path
      const downloadName = key.split('/').reverse()[1];
      const getURL = async () => {
        const params = {
          Bucket: config.UserBucket,
          Key: key,
          Expires: 60,
          ResponseContentDisposition: `attachment; filename=${downloadName}_${sizeDescription}.jpg`
        };
        const url = await async_getSignedURL(params);
        dispatch(s3UserImages.alternateSizeDone(key));
        window.location.href = url;
      };
      getURL();
      return;
    }
    const size = {
      description: sizeDescription,
      dimensions: {
        width: width,
        height: height
      }
    };
    const getter = async () => {
      const result = await getResizedLibraryImage(key, size, dispatch);
      dispatch(s3UserImages.alternateSizeDone(key));
      window.location.href = result['download_url'];
    };
    getter();
  };

  render() {
    const {
      height,
      downloading,
      sizeDescription,
      width,
      imageKey,
      sizeDisplay
    } = this.props;
    return (
      <div>
        {height === 0 && <Spinner type="library" />}
        {height > 0 && (
          <div>
            {downloading === sizeDescription && <Spinner type="library" />}
            {downloading !== sizeDescription && (
              <Button
                className="library-size-option"
                onClick={e => {
                  e.preventDefault();
                  return this.requestImageAtSize(
                    width,
                    height,
                    sizeDescription,
                    imageKey
                  );
                }}
              >
                <span>
                  {sizeDisplay} ({width} x {height})
                </span>
              </Button>
            )}
            <br />
            <br />
          </div>
        )}
      </div>
    );
  }
}

class ImageButtonGroup_Class extends React.Component {
  componentDidMount() {
    const {
      dispatch,
      image: { Key }
    } = this.props;
    getImageMetaData(Key, dispatch, 'UserBucket');
  }

  calculateImageWidth = (newHeight, originalWidth, originalHeight) => {
    return Math.round(
      newHeight * (Number(originalWidth) / Number(originalHeight))
    );
  };

  render() {
    const {
      metaData,
      image: { Key, downloading }
    } = this.props;
    const imageMetaData = metaData[Key];
    let originalHeight = 0;
    let originalWidth = 0;
    if (imageMetaData) {
      originalHeight = Number(imageMetaData.height);
      originalWidth = Number(imageMetaData.width);
    }
    return (
      <div>
        <ImageButton
          downloading={downloading}
          sizeDescription="fullsize"
          sizeDisplay="Full Size"
          width={originalWidth}
          height={originalHeight}
          imageKey={Key}
        />
        {originalHeight > 1080 && (
          <ImageButton
            downloading={downloading}
            sizeDescription="large"
            sizeDisplay="Large"
            width={this.calculateImageWidth(
              1080,
              originalWidth,
              originalHeight
            )}
            height={1080}
            imageKey={Key}
          />
        )}
        {originalHeight > 768 && (
          <ImageButton
            downloading={downloading}
            sizeDescription="medium"
            sizeDisplay="Medium"
            width={this.calculateImageWidth(768, originalWidth, originalHeight)}
            height={768}
            imageKey={Key}
          />
        )}
        {originalHeight > 500 && (
          <ImageButton
            downloading={downloading}
            sizeDescription="small"
            sizeDisplay="Small"
            width={this.calculateImageWidth(500, originalWidth, originalHeight)}
            height={500}
            imageKey={Key}
          />
        )}
      </div>
    );
  }
}

class ImageGrid_Class extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    getMyUploads(dispatch);
  }

  renderDate = date => {
    return date.getDate() + '/' + date.getMonth() + '/' + date.getFullYear();
  };

  render() {
    const { images, imageCount } = this.props;
    const listicle = images.map((image, index) => {
      const angle = Math.floor(Math.random() * (11 - 5) + 5);
      const date = image.LastModified;
      return (
        <div className="pic-actions" key={image.Key}>
          <PreviewCard
            generated={date}
            imageKey={image.Key}
            thumbKey={image.Key.replace('fullsize', 'thumbnail')}
            angle={`${'-+'[index % 2]}${angle}`}
          />
          <h2>
            Download again
            <small>
              &nbsp;
              {this.renderDate(date)}
            </small>
          </h2>
          <ImageButtonGroup image={image} />
        </div>
      );
    });
    const imagesDisplay = chunk(listicle, 1)
      .slice(0, imageCount)
      .map((part, index) => <Row key={index}>{part}</Row>);
    return (
      <div>
        <h1>Your Pics</h1>
        {imagesDisplay}
      </div>
    );
  }
}

class LibraryBody_Class extends React.Component {
  displayMore = () => {
    const { dispatch } = this.props;
    displayMore(dispatch, 'libraryMoreButton');
  };

  render() {
    const { userImages, imageCount, displayCountStatus } = this.props;
    const image_data = userImages
      // We only want to display the full size images in the library, not any other-sized ones that may have been generated
      .filter(image => image.Key.endsWith('fullsize'))
      .sort((a, b) => {
        return b.LastModified - a.LastModified;
      });
    return (
      <Grid id="library-container">
        <ImageGrid images={image_data} />
        <div className="pagination">
          <button
            className="btn btn-secondary btn-bevel"
            onClick={this.displayMore}
            disabled={image_data.length <= imageCount}
          >
            {displayCountStatus !== users.types.DISPLAYING_MORE && (
              <span>More</span>
            )}
            {displayCountStatus === users.types.DISPLAYING_MORE && (
              <Spinner type="moreButton" />
            )}
          </button>
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  userImages: state.userImages.images,
  metaData: state.userImages.imagesMetaData,
  signedImageURLs: state.userImages.signedImageURLs,
  signedThumbnailURLs: state.userImages.signedThumbnailURLs,
  imageCount: state.users.libraryDisplayCount,
  displayCountStatus: state.users.displayCountStatus
});

const ImageGrid = connect(mapStateToProps)(ImageGrid_Class);
const ImageButton = connect(mapStateToProps)(ImageButton_Class);
const ImageButtonGroup = connect(mapStateToProps)(ImageButtonGroup_Class);
const LibraryBody = connect(mapStateToProps)(LibraryBody_Class);
const PreviewCard = connect(mapStateToProps)(PreviewCard_Class);

export default Library;



// WEBPACK FOOTER //
// ./src/comps/Library/Library.js